import React from "react";
import loadable from "@loadable/component";
import { useLocation, useParams } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../customHooks/useGetHook";
import APIS from "../constant/Endpoint";
import Spinner from "../components/Reusable/Spinner";
import useDeleteHook from "../customHooks/useDeleteHook";
const FoldersComponent = loadable(() => import("../components/Folders"));
const Folders = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const id = pathSegments[pathSegments.length - 1] || "root";

  const { data } = useGetHook({
    queryKey: [`folder-${id}`],
    url: `${APIS.FOLDER}${id}/`,
    params: {},
  });
  const { data: fileList, isLoading } = useGetHook({
    queryKey: ["file", `file-${id}`],
    url: `${APIS.FILE}`,
    params: {
      folder: id,
    },
  });
  const { data: folderList, isLoading: isfolderListLoading } = useGetHook({
    queryKey: ["folder", `folder-${id}`],
    url: `${APIS.FOLDER}`,
    params: {
      parent: id,
    },
  });

  const { mutateAsync, isLoading: isdeleteLoading } = useDeleteHook({
    queryKey: ["file"],
  });
  const { mutateAsync: deletefolder, isLoading: isDeleting } = useDeleteHook({
    queryKey: ["folder"],
  });

  const handleDeleteFile = async (id: any) => {
    const url = `${APIS.FILE}${id}/`;
    try {
      await mutateAsync({ url });
    } catch (err) {
      console.error(err);
    }
  };
  const handleDeleteFolder = async (id: any) => {
    const url = `${APIS.FOLDER}${id}/`;
    try {
      await deletefolder({ url });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`container mx-auto px-4`}>
      {isLoading || isfolderListLoading ? (
        <Spinner />
      ) : (
        <FoldersComponent
          data={data}
          fileList={fileList}
          folderList={folderList}
          handleDeleteFile={handleDeleteFile}
          handleDeleteFolder={handleDeleteFolder}
          isdeleteLoading={isdeleteLoading}
          isDeleting={isDeleting}
        />
      )}
    </div>
  );
};

export default Folders;
